import React from "react";
import Button from "@mui/material/Button";
import Colors from "./Colors";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

function PlayButtonComponent({ onClick, sx, ...props }) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        width: "100%",
        height: { xs: "24px", md: "40px" },
        backgroundColor: Colors.typoblue2,
        borderRadius: { xs: "8px", md: "12px" },
        color: Colors.white,
        textTransform: "none",
        fontFamily: "Boogaloo",
        padding: { xs: "0px 8px", md: "0px 10px" },
        border: `2px solid ${Colors.white}`,
        fontSize: { xs: "12px", md: "20px" },
        fontWeight: 600,
        gap: { md: "8px", xs: "4px" },
        // '&:hover': {
        //     background: Colors.orangeSecondary, textTransform: 'none', color: Colors.white,
        //   },
        ...sx,
      }}
      {...props}
    >
      <PlayArrowIcon /> Play Now
    </Button>
  );
}
export default PlayButtonComponent;
